import React, { Fragment, useEffect, useRef, useState } from "react";
import Button from "../components/common/button";
import { useNavigate } from "react-router-dom";
import * as userService from "../utils/userService";
import * as httpService from "../services/httpService";
import { Employee_Api_EndPoints } from "../global/end-points";
import LoadingSpinner from "../components/common/loadingSpinner";
import { useTranslation } from "react-i18next";
import NoDoughCardMessage from "../components/common/nodoughcard_message";
import PrivilegeService from "../services/PrivilegeService";


function DoughCard() {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const didMount = useRef(false);
  const [balance, SetBalance] = useState(0);
  const [cardLast4Digits, setCardLast4Digits] = useState("");
  const [errorMessage, setErrorMessage] = useState({
    title: "warning",
    content: "This is a sample content"
  });
  const [isError, setIsError] = useState(false);
  const [privilegesChecked, setPrivilegesChecked] = useState(false);

  useEffect(() => {
    // Get privileges from sessionStorage
    const privilegesObj = JSON.parse(sessionStorage.getItem("Privileges") || "{}");
    const hasAccess = PrivilegeService.hasReadAccess(privilegesObj, "DoughCard");
    if (!hasAccess) {
      setErrorMessage({
        title: "Access Denied",
        content: "You do not have permission to view this page."
      });
      setIsError(true);
      setPrivilegesChecked(true);
    } else {
      setPrivilegesChecked(true);
      if (!didMount.current) {
        getBalance();
      }
    }
    return () => {
      didMount.current = true;
    };
  }, []);

  const getBalance = () => {
    if (sessionStorage.UserId != undefined) {
      const body = {
        UserId: Number(sessionStorage.UserId),
      };
      httpService.Get(Employee_Api_EndPoints.GET_BALANCE, body).then((resp) => {
        if (resp.status == 200 && !resp.data.errorFound) {
          if(typeof resp.data.cardBalance === 'undefined' && typeof resp.data.cardLast4Digits === 'undefined'){
            setDoughCardError();
          }
          else{
            SetBalance(resp.data.cardBalance);
            setCardLast4Digits(resp.data.cardLast4Digits);
          }
        }
        else
        {
          setDoughCardError();
        }
        setIsLoad(true);
      });
    } else {
      setIsLoad(true);
      userService.ClearSession();
    }
  };

  const toNavigate = (event) => {
    event.preventDefault();
    switch (event.target.value) {
      case "tranctions":
        navigate("/servicetransaction");
        break;
      case "doughdepotransaction":
        navigate("/depotransaction");
        break;
      case "dchtobank":
        navigate("/achtransaction");
        break;
      case "otherActions":
        navigate("/othertransaction");
        break;
    }
  };

  const setDoughCardError = () => {
    setErrorMessage({
      title: 'Message',
      content: "Your DoughCard creation is pending, this may take few minutes. If it takes too long please contact 'Instadough Techsupport'"
    });
    setIsError(true);
  }

  const handleClosePopup = () => {
    setIsError(false);
    navigate(-1);
  }

  // Wait for privilege check before rendering anything
  if (!privilegesChecked) return <LoadingSpinner />;

  return (
    <Fragment>
      {isLoad && !isError && (
        <Fragment>
          {/* <!-- dashboard main start --> */}
          <div className="dashboard-container">
            <h2 className="page-module-heading mb-15">{t("YourDoughCard")}</h2>
            <div className="your-dough-card-continer">
              {/* <!-- card inner start --> */}
              <div className="summary-card-inner">
                {/* <!-- card details start --> */}
                <div className="summary-card-details">
                  <h2 className="card-heading">{t("doughcardsummary")}</h2>
                  <h2 className="wages-heading">{t("doughcardWagestoAccess")}</h2>
                  <h2 className="wage-amount-no-link">
                    $ {balance.toFixed(2)}
                  </h2>
                  <h3 className="wage-card-number">**** **** **** {cardLast4Digits}</h3>
                  <div className="card-holder-details-provider">
                    <div className="card-holder-details">
                      <div className="valid">
                        Valid Thru
                        <span>08/28</span>
                      </div>
                      <div className="valid">
                        Card holder
                        <span>{sessionStorage?.UserName}</span>
                      </div>
                    </div>
                    <div className="card-provider-symbol">
                      <img src="./images/card-provider-logo.svg" alt="" />
                    </div>
                  </div>
                </div>
                {/* <!-- card details end --> */}
              </div>
              {/* <!-- card inner end --> */}
            </div>
            <h2 className="page-module-heading">
              {t("Youhave")}{" "}
              <span className="color-white">$ {balance.toFixed(2)}</span> {t("yourDoughCard")}
            </h2>
            <div className="paydata-home mt-30">
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("RecentDoughCardTrs")}
                value="tranctions"
                onClick={toNavigate}
              />
               <Button
                className="btn btn-paydata w-100-percent"
                label={t("RecentDoughDepoTrs")}
                value="doughdepotransaction"
                onClick={toNavigate}
              />
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("DhAchBank")}
                value="dchtobank"
                onClick={toNavigate}
              />
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("OtherAct")}
                value="otherActions"
                onClick={toNavigate}
              />
            </div>
          </div>
          {/* <!-- dashboard main end --> */}
        </Fragment>
      )}
      {!isLoad && !isError && <LoadingSpinner />}
      {isError && (
        <NoDoughCardMessage 
          title={errorMessage.title}
          message={errorMessage.content}
          onClose={handleClosePopup}
        />
      )}
    </Fragment>
  );
}
export default DoughCard;
